module.exports = __webpack_public_path__ + "static/media/noImage.b7d7f917.svg";